import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LayoutMain from '../LayoutMain/LayoutMain';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import WaterMark from "../DashboardMain/WaterMark";
import { decodeToken } from "react-jwt";
import { BsHexagon } from "react-icons/bs";

const SESSION_IDEL_MINUTES = 1;

function Realtime() {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [isRealTimeDashboard, setIsRealTimeDashboard] = useState(false)
    const [isRangePolygon, setIsRangePolygon] = useState(false)

    useEffect(() => {
        fetchData({
            url: API_URL_MAIN + "auth/logging", body: {
                page_name: "vehicleinsights"
            }
        })
    }, []);

    useEffect(() => {
        const tokenNew = JSON.parse(sessionStorage.user);
        let decodedToken = decodeToken(tokenNew.token);
        const usernameNew = decodedToken.access_type;
        var split_str = usernameNew.split(",");
        if (split_str.indexOf("16") !== -1) {
            setIsRealTimeDashboard(true)
        }
        if (split_str.indexOf("17") !== -1) {
            setIsRangePolygon(true)
        }
    }, [isRealTimeDashboard, isRangePolygon]);

    return (
        <>
            <LayoutMain>
                <div className="row">
                    <WaterMark />
                    {
                        isRealTimeDashboard &&
                        <div className="col-md-3 " style={{}}>
                            <Link to="/realtime/digitalinstrumentcluster">
                                <div className="dashboard_card ev_card_title">
                                    <img src="../../../assets/img/real_time_fault_code_icon.png" />
                                    <span>Real Time Summary</span>
                                </div>
                            </Link>
                        </div>
                    }
                    {
                        isRangePolygon &&
                        <div className="col-md-3 " style={{}}>
                            <Link to="/realtime/rangepolygon">
                                <div className="dashboard_card ev_card_title">
                                    <BsHexagon style={{ color: "#32879c" }} size={50} />
                                    {/* <img src="../../../assets/img/real_time_fault_code_icon.png" /> */}
                                    <span>Range Polygon</span>
                                </div>
                            </Link>
                        </div>
                    }
                </div>
            </LayoutMain>
        </>
    );
}
export default Realtime;
